<template>
  <div class="ppt_wrap">
    <div class="ppt_banner">
      <div class="banner_desc">
        <div class="banner_icon">
          <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/ppt_banner_icon.png" alt="">
        </div>
        <div class="banner_title">AIGC赋能办公新范式</div>
        <div class="banner_content">开放AiPPT能力底座，便捷接入平台，助力合作伙伴<br />快速构建Ai生成PPT产品</div>
        <el-button class="banner_button" @click="goContact">联系我们</el-button>
      </div>
    </div>
    <div class="ppt_content">
      <div class="content_box">
        <div class="content_title">丰富的AiPPT能力，满足多场景需求</div>
        <div class="ppt_swiper">
          <div class="swiper_nav">
            <div v-for="item in swiperNav" :key="item.id" class="nav_item" :style="{opacity: item.id === currentId ? '1' : '0.5'}" @mouseenter="handleSwiper(item)">
              <span class="swiper_icon"><img :src="icons[item.id]" alt=""></span>
              <span class="swiper_text">{{ item.text }}</span>
            </div>
          </div>
          <div class="swiper_content">
            <div class="swiper_item" :style="{top: (img.id === currentId) ? '0' : '100%', opacity: (img.id === currentId) ? '1' : '0'}" v-for="img in swiperPics" :key="img.id">
              <div class="item_left">
                <div class="item_icon">
                  <img :src="icons[img.id]" alt="">
                </div>
                <div class="item_title">{{ img.title }}</div>
                <div class="item_desc" v-html="img.desc"></div>
                <el-button class="item_button" @click="goContact">立即申请</el-button>
              </div>
              <div class="item_right">
                <img :src="img.url" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_advantage">
        <div class="advantage_container">
          <div class="advantage_title">合作优势</div>
          <div class="feature">
            <div class="feature_item" v-for="item in advantage" :key="item.id">
              <div class="feature_icon">
                <img :src="item.icon" alt="">
              </div>
              <div class="feature_title">{{ item.title }}</div>
              <div class="feature_desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      swiperNav: [
        { id: 0, text: '一键生成' },
        { id: 1, text: '文档导入' },
        { id: 2, text: '思维导图' },
        { id: 3, text: '在线演示' },
        { id: 4, text: '在线编辑' },
        { id: 5, text: 'PPT下载' }
      ],
      swiperPics: [
        {
          id: 0,
          title: '一键生成',
          desc: '全流程智能生成能力，只需输入一句主题，<br/>快速生成大纲以及具有专业外观的演示PPT',
          url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/one_touch_pic.png'
        },
        {
          id: 1,
          title: '文档导入',
          desc: '多种格式文档导入无忧，支持 docx、xmind、<br/>freemind、markdown 文件导入直接生成 PPT',
          url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/word.png'
        },
        {
          id: 2,
          title: '思维导图',
          desc: '拆解内容思维导图，在线直观预览内容，支持<br/>在线预览、编辑，可一键下载为文本或图片格式',
          url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/mind.png'
        },
        {
          id: 3,
          title: '在线演示',
          desc: '无需下载，在线即可无忧演示PPT；字体、设<br/>计、表格等无差别演示，无需担心下载格式转换',
          url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/ppt.png'
        },
        {
          id: 4,
          title: '在线编辑',
          desc: '生成结果在线编辑调整，支持文本、图片、表<br/>格、图表、主题、模板等全内容编辑调整，更<br/>可一键替换整套模板',
          url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/editor.png'
        },
        {
          id: 5,
          title: 'PPT下载',
          desc: '支持将在线作品保存到本地, 可选格式包含:<br/>PPT、PDF、PNG、JPEG',
          url:'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/ppt_download.png'
        }
      ],
      currentId: 0,
      advantage: [
        {
          id: 0,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/icon1.png',
          title: '最新功能同步',
          desc: 'AiPPT产品能力不断更新同步'
        },
        {
          id: 1,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/icon2.png',
          title: '高效便捷服务',
          desc: '最快3个工作日完成对接'
        },
        {
          id: 2,
          icon: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/icon3.png',
          title: '全方位接口能力',
          desc: 'SDK+API 多样化合作方式'
        },
      ]
    }
  },
  computed:{
    icons() {
      return [
        'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/one_touch.png',
        'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/word_icon.png',
        'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/mind_icon.png',
        'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/ppt_icon.png',
        'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/editor_icon.png',
        'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/content/ppt_download_icon.png'
      ]
    }
  },
  mounted() {
    setInterval(()=>{
      if (this.currentId < 5) {
        this.currentId++
      } else {
        this.currentId = 0
      }
    }, 3000)
  },
  methods: {
    goContact() {
      const route = this.$router.resolve({ path: "/contact" });
      window.open(route.href, "_blank");
    },
    handleSwiper(item) {
      this.currentId = item.id
    },
  }
}
</script>

<style lang="scss" scoped>
.ppt_wrap {
  width: 100%;
  padding-top: 60px;
  .ppt_banner {
    width: 100%;
    min-width: 1400px;
    height: 460px;
    background-image: url("https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/AIPPT/ppt_banner.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center;
    position: relative;
    .banner_desc {
      position: absolute;
      top: 101px;
      left: 20%;
      .banner_icon {
        width: 200px;
        height: 44px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .banner_title {
        font-size: 48px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #3B3946;
        line-height: 67px;
        margin-top: 8px;
        margin-bottom: 16px;
      }
      .banner_content {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #3B3946;
        line-height: 22px;
      }
      .banner_button {
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        border-color: #5A2DF5;
        color: #fff;
        margin-top: 40px;
      }
    }
  }
  .ppt_content {
    width: 100%;
    background-color: #ffffff;
    .content_box {
      width: 1200px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-top: 104px;
      padding-bottom: 118px;
      text-align: center;
      .content_title {
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #141414;
        line-height: 45px;
        margin-bottom: 63px;
      }
      .ppt_swiper {
        width: 100%;
        .swiper_nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .nav_item {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 68px;
            cursor: pointer;
            user-select: none;
            font-size: 18px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #141414;
            line-height: 25px;
            .swiper_icon {
              width: 37px;
              height: 37px;
              margin-right: 4px;
            }
            .swiper_text {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3B3946;
              line-height: 22px;
            }
          }
        }
        .swiper_content {
          width: 100%;
          height: 584px;
          margin-top: 44px;
          border-radius: 60px 60px 60px 0;
          overflow: hidden;
          position: relative;
          .swiper_item {
            width: 100%;
            height: 100%;
            border-radius: 60px 60px 60px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #EBDDFF;
            position: absolute;
            transition: top 0.3s ease-in-out 0s, opacity 0.5s ease-in-out 0s;
            padding-left: 100px;
            .item_left {
              height: 100%;
              padding-top: 81px;
              text-align: left;
              .item_icon {
                width: 76px;
                height: 76px;
                margin-left: -8px;
                margin-bottom: 32px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .item_title {
                font-size: 40px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #1F1406;
                line-height: 56px;
                margin-bottom: 35px;
              }
              .item_desc {
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #1F1406;
                line-height: 28px;
                word-break: normal;
                white-space: nowrap;
                margin-bottom: 52px;
              }
              .item_button {
                width: 166px;
                height: 46px;
                background: #3F0D52;
                border-radius: 23px;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                border: none;
                &:hover {
                  background: #3F0D52;
                  opacity: .8;
                }
              }
            }
            &:nth-child(2), &:nth-child(5) {
              background-color: #D8EAFF;
              .item_button {
                background-color: #121C48;
                &:hover {
                  background: #121C48;
                }
              }
            }
            &:nth-child(3), &:nth-child(6) {
              background-color: #FFE5BA;
              .item_button {
                background-color: #513E0D;
                &:hover {
                  background: #513E0D;
                }
              }
            }
            .item_right {
              height: 100%;
              display: flex;
              align-items: center;
              img {
                width: 707px;
                height: 485px;
                object-fit: contain;
              }
              &:nth-child(2){
                img {
                  width: 607px;
                  height: 455px;
                }
              }
              &:nth-child(3){
                img {
                  width: 634px;
                  height: 421px;
                }
              }
              &:nth-child(4){
                img {
                  width: 600px;
                  height: 373px;
                }
              }
              &:nth-child(5){
                img {
                  width: 642px;
                  height: 556px;
                }
              }
              &:nth-child(6){
                img {
                  width: 600px;
                  height: 439px;
                }
              }
            }
          }
        }
      }
    }
    .content_advantage {
      width: 100%;
      height: 538px;
      background-color: #F7F9FA;
      .advantage_container {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        padding: 104px 0;
        .advantage_title {
          font-size: 32px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #141414;
          line-height: 45px;
          margin-bottom: 56px;
          text-align: center;
        }
        .feature {
          width: 100%;
          height: 229px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .feature_item {
            width: 332px;
            height: 100%;
            border-radius: 24px;
            background-color: #ffffff;
            text-align: center;
            padding-top: 38px;
            .feature_icon {
              width: 100%;
              height: 66px;
              text-align: center;
              img {
                width: 66px;
                height: 100%;
              }
            }
            .feature_title {
              font-size: 22px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: #141414;
              line-height: 30px;
              margin-top: 24px;
              margin-bottom: 16px;
            }
            .feature_desc {
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #575759;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}
</style>
